import { render, staticRenderFns } from "./GiveAccessModal.vue?vue&type=template&id=2b58b5f3&scoped=true&"
import script from "./GiveAccessModal.vue?vue&type=script&lang=js&"
export * from "./GiveAccessModal.vue?vue&type=script&lang=js&"
import style0 from "./GiveAccessModal.vue?vue&type=style&index=0&id=2b58b5f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b58b5f3",
  null
  
)

export default component.exports